import React, { Component } from 'react';
import { Button, Form, FormGroup, Label, Input, FormText, Card, CardBody, CardTitle } from 'reactstrap';
import { connect } from 'react-redux'
import {withRouter} from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.css';

class FileTypeMetaCategories extends Component {

    constructor(props,context) {
        super(props,context);

        this.mapMetaCategories = this.mapMetaCategories.bind(this);
        this.mapMetaTextValues = this.mapMetaTextValues.bind(this);
        this.checkForChecked = this.checkForChecked.bind(this);
        this.getTextValue = this.getTextValue.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.state = {attached_values: false, selectedValues: this.props.attachedValues ? this.props.attachedValues : []}

        // -- set locale
        moment.locale('nl');
    }


    mapMetaCategories(categoryObject, key) {
     
        if(this.props.metaDataValueByCategory[categoryObject.id]) {
            return (
              <span key={key}>
                  <div  className="table-style col-md-3" key={key} style={{float: 'left','paddingLeft': '0px', 'minHeight': '210px'}}>
                    <div  className="table-style-header"><strong>{this.props.metaDataValueByCategory[categoryObject.id].category} {categoryObject.is_mandatory === '1' ? '*' : ''}</strong></div>
                    {categoryObject.is_text === '1' ? 
                        this.props.metaDataValueByCategory[categoryObject.id].values.map((value, key) => this.mapMetaTextValues(value, categoryObject.id))
                    :
                    <FormGroup key={categoryObject.id}>
                        <Select                                                  
                            simpleValue={true}
                            multi={categoryObject.is_unique === '1' ? false : true}
                            value={this.getSelectedValue(categoryObject.id)}
                            onChange={value => this.setSelectedValue(value, categoryObject.id)}                         
                            options={this.props.metaDataValueByCategory[categoryObject.id].values.map((value, key) => this.mapMetaSelectValues(value, categoryObject.id))}
                          />    
                    </FormGroup>
                   }

                  </div>
              </span>

            )
        }
    }

    mapMetaTextValues(valueObject, key) {     
   
        return (
             <FormGroup key={valueObject.id}>
                <Label onClick={e => e.preventDefault()}>
                    {valueObject.is_date === '1' ?
                         <DatePicker autoComplete="off" dateFormat="DD-MM-YYYY" locale='nl-nl' selected={this.state['date_'+key] ? this.state['date_'+key] : this.getTextValue(valueObject.id) !== null ? moment(this.getTextValue(valueObject.id) , "DD-MM-YYYY") : null} data-categoryid={key} onChange={(date) => this.handleDateChange(date, key)} onBlur={(e) => this.props.setTextValue(e)} name={key}  />
                        :
                        <Input autoComplete="off" defaultValue={this.getTextValue(valueObject.id, key)} type="text" data-categoryid={key} onChange={(e) => this.props.setTextValue(e)} name={key} />
                    }
                   &nbsp;{valueObject.name}
                </Label>
            </FormGroup>
        )       
    }

    mapMetaSelectValues(valueObject, key) {               
        return ({value: valueObject.id, label: valueObject.name})
    }
    
    setSelectedValue(value, categoryId) {
        // -- set local state       
        this.setState({selectedValues: {...this.state.selectedValues,[categoryId]:value}})

        // -- add value to parent state
               
        this.props.setCheckedValue(value, categoryId);
               
    }

    getSelectedValue(categoryId) {
        if(categoryId in this.state.selectedValues) {
            return this.state.selectedValues[categoryId];
        }

        return null;

    }


    checkForChecked(valueId) {
        if(!this.props.attachedValues) {
            return false;
        }

        if(valueId in this.props.attachedValues){
            return true;
        }

        return false;
    }

   getTextValue(valueId, valueObject) {

        if(!this.props.attachedValues)
                return null;

        

        if(this.props.attachedValues[valueId+'_text']) {
            return this.props.attachedValues[valueId+'_text']
        } else {
            return null;
        }
   }


   handleDateChange(date, key) {

        this.setState({['date_'+key]: date })
   }


    render() {

        const fileType = this.props.fileTypeData.data.find(e => e.id == this.props.type_id);

        return (
           <span>{ fileType.metacategories.map((category, key) => this.mapMetaCategories(category, key))}</span>
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {

        clientPath: state.clientPathReducer,
        fileTypeData: state.FileTypeDataReducer,
        metaDataValueByCategory:state.FileMetaDataValueReducer.dataWithCategory
    }
}

export default withRouter(connect(mapStateToProps)(FileTypeMetaCategories))



// WEBPACK FOOTER //
// ./src/views/Files/Form/FileMetaForm/FileTypeMetaCategories.js